import { render } from "./ChallengeDetail.vue?vue&type=template&id=ac956b00&scoped=true"
import script from "./ChallengeDetail.vue?vue&type=script&lang=js"
export * from "./ChallengeDetail.vue?vue&type=script&lang=js"

import "./ChallengeDetail.vue?vue&type=style&index=0&id=ac956b00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac956b00"]])

export default __exports__